import {
  Box,
  Button,
  Snackbar,
  Typography
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import React, { useState } from 'react';

import { Voter } from '../../types';
import VoterListControl from './VoterListControl';
import useAuth from '../../hooks/useAuth';

interface VoterListProps {
}

const VoterList: React.FC<VoterListProps> = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const onVoterEdit = async (voter: Voter) => {
    navigate(`/voters/edit/${voter.id}`);
  };

  const onVoterDelete = async (voter: Voter) => {
    setSnackbarMessage(`Voter ${voter.name} has been deleted`);
    setSnackbarOpen(true);
  };

  const onViewDetails = async (voter: Voter) => {
    navigate(`/voters/details/${voter.id}`);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h4">Voter List</Typography>
        {user?.permissions?.manage_voters && (
          <Box>
            <Button component={Link} to="/voters/new" variant="contained" color="primary">
              New Voter
            </Button>
          </Box>
        )}
      </Box>
      <VoterListControl onEdit={onVoterEdit} onDelete={onVoterDelete} onViewDetails={onViewDetails}/>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
      />
    </Box>
  );
}

export default VoterList;
